<template>
    <div class="order-processing-steps">
        <div v-if="loading">
            <div class="text-muted">Loading checklist...</div>
        </div>
        <div v-else-if="!loading && steps.length === 0">
            <div class="text-muted">This order does not have processing steps. Order processing steps are added to an order after the order has been paid.</div>
        </div>
        <div v-else>
            <ProcessingStep :key="step.type" :step="step" v-for="step in steps" :order-id="orderId" :partner-id="partnerId" :on-update="handleStepUpdate" ref="stepRefs" />
            <div v-if="allCompleted && completeButtonId" class="text-right">
                <strong class="text-success align-middle">All steps are completed.</strong>
                <button class="btn btn-sm btn-success" @click="setOrderToHandled" :disabled="loadingSetHandled"><i v-if="loadingSetHandled" class="mdi mdi-loading mdi-spin" /> Set order to HANDLED</button>
            </div>
        </div>

    </div>
</template>

<script>
import ProcessingStep from './ProcessingStep';

export default {
    name: "OrderAdminChecklist",

    mounted () {
        this.fetchChecklist();
    },

    data: () => ({
        loading: true,
        loadingSetHandled: false,
        error: null,
        steps: [],
        stepRefs: []
    }),

    computed: {
        allCompleted: function () {
            return this.steps.filter(s => s.is_completed === true).length === this.steps.length;
        }
    },

    methods: {

        setOrderToHandled () {
            if (!this.completeButtonId || this.loadingSetHandled) return;

            this.loadingSetHandled = true;
            document.getElementById(this.completeButtonId).click();
        },

        handleStepUpdate ({ type, is_completed }) {
            const stepIndex = this.steps.findIndex(s => s.type === type);

            const updatedStep = this.steps[stepIndex];
            updatedStep.type = type;
            updatedStep.is_completed = is_completed;

            this.$set(this.steps, stepIndex, updatedStep)
        },

        fetchChecklist(options) {
            this.loading = true;
            this.error = null;

            axios.get(`/admin/api/partner/${this.partnerId}/order/${this.orderId}/processing-steps`).then(res => {
                if (Array.isArray(res.data)) {
                    const data = res.data;
                    data.sort((a, b) => a.sort_order - b.sort_order);

                    this.steps = data;
                    this.loading = false;

                    return;
                }

                this.steps = [];
                this.error = "Unexpected response from server.";
                this.loading = false;
            }).catch(err => {
                if (err?.response?.error) {
                    this.error = err.response.error;
                    return;
                }

                if (err?.response) {
                    this.error = err.response.toString();
                    return;
                }

                this.error = err.toString();
            })
        }

    },

    props: {
        orderId: {
            type: String,
            required: true
        },
        partnerId: {
            type: String,
            required: true
        },
        completeButtonId: {
            type: String,
        }
    },

    components: {
        ProcessingStep
    }

};
</script>

<style scoped>

</style>
